(function(){
  "use strict";
  function ready(fn){if(document.readyState==="loading"){document.addEventListener("DOMContentLoaded",fn);}else{fn();}}
  ready(function(){
    var API="https://zkuiyjfozeouawwqdrgj.supabase.co/functions/v1/cartverio-execution-approval-api";
    var token=new URLSearchParams(window.location.search).get("token")||"";
    var content=document.getElementById("ap-content");
    var err=document.getElementById("ap-error");
    if(!content||!err){return;}
    function setText(id,value){var el=document.getElementById(id);if(el){el.textContent=value||"";}}
    function fail(message){err.hidden=false;err.textContent=message||"This approval link is unavailable.";}
    if(!token){fail("This approval link is missing or invalid.");return;}

    fetch(API+"?token="+encodeURIComponent(token),{cache:"no-store"})
      .then(function(r){return r.json().catch(function(){return null;}).then(function(d){if(!r.ok||!d||d.ok!==true){throw new Error("This approval link is unavailable or expired.");}return d;});})
      .then(function(d){
        var t=d.task||{};
        var p=d.project||{};
        setText("ap-title",t.title||"Review proposed change");
        setText("ap-project",p.website||"");
        setText("ap-priority",t.priority||"");
        setText("ap-type",t.action_type||"");
        setText("ap-risk","Risk: "+(t.risk_level||""));
        if(t.target_url){
          var target=document.getElementById("ap-target");
          target.hidden=false;
          target.textContent="Target: "+t.target_url;
        }
        setText("ap-evidence",t.evidence||"");
        setText("ap-proposal",JSON.stringify(t.proposed_change||{},null,2));
        if(d.decision||d.can_decide===false){
          var existing=document.getElementById("ap-existing");
          existing.hidden=false;
          existing.textContent=d.decision?
            "Decision already recorded: "+d.decision:
            "This task is no longer awaiting approval. No action can be taken from this link.";
          document.getElementById("ap-buttons").hidden=true;
        }
        content.hidden=false;

        Array.prototype.forEach.call(document.querySelectorAll("#ap-buttons button"),function(btn){
          btn.addEventListener("click",function(){
            var choice=String(btn.getAttribute("data-decision")||"");
            if(choice==="approved"){
              var op=(t.proposed_change&&t.proposed_change.shopify_operation)||{};
              var message="Confirm approval for CARTVERIO\n\n"+
                "Task: "+String(t.title||"Proposed change").slice(0,180)+"\n\n"+
                (op.type==="publish_page"?
                  "WARNING: This action will publish content to the Shopify storefront.\n\n":
                  op.type==="create_page_draft"?
                  "This action creates an UNPUBLISHED Shopify draft. Publishing requires separate approval.\n\n":
                  "This authorizes CARTVERIO to execute the selected task.\n\n")+
                "Choose OK to APPROVE, or Cancel to go back.";
              if(!window.confirm(message))return;
            }else if(choice!=="rejected"){fail("Unrecognized decision.");return;}
            Array.prototype.forEach.call(document.querySelectorAll("#ap-buttons button"),function(b){b.disabled=true;});
            fetch(API,{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify({token:token,decision:choice})})
              .then(function(r){return r.json().catch(function(){return null;}).then(function(x){if(!r.ok||!x||x.ok!==true){throw new Error(x&&x.error==="already_decided"?"This decision has already been recorded.":"Could not save decision.");}return x;});})
              .then(function(x){
                var existing=document.getElementById("ap-existing");
                existing.hidden=false;
                existing.textContent="Decision recorded: "+x.decision;
                document.getElementById("ap-buttons").hidden=true;
              })
              .catch(function(e){
                fail(e&&e.message?e.message:"Could not save decision.");
                Array.prototype.forEach.call(document.querySelectorAll("#ap-buttons button"),function(b){b.disabled=false;});
              });
          });
        });
      })
      .catch(function(e){fail(e&&e.message?e.message:"This approval link is unavailable.");});
  });
})();